{
	"title": "Garantir la redevabilité en mettant en place une banque carbone",
	"description": "Heidelberg Materials a pris des mesures approfondies afin de garantir la crédibilité des réductions de carbone générées par notre cimenterie équipée de CSC. Afin d’éviter toute possibilité de double comptabilisation, nous avons mis en place une banque carbone virtuelle sécurisée sur un registre distribué public.",
	"traceabilityTitle": "Traçabilité des réductions de carbone"
}
